var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCollabApply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Collab / Apply"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.7028 6.97345L3.85553 1.35431C3.64791 1.23801 3.4098 1.18768 3.17287 1.21C2.93594 1.23233 2.71143 1.32626 2.52919 1.47931C2.34695 1.63235 2.21563 1.83725 2.15268 2.06675C2.08974 2.29625 2.09816 2.53948 2.17682 2.76408L3.94518 8.00002L2.17682 13.236C2.11465 13.4126 2.09572 13.6016 2.1216 13.787C2.14749 13.9725 2.21745 14.149 2.32561 14.3019C2.43377 14.4548 2.57699 14.5795 2.74327 14.6656C2.90956 14.7517 3.09405 14.7967 3.28131 14.7969C3.48269 14.7965 3.68059 14.7444 3.85612 14.6457L3.86139 14.6422L13.7051 9.0131C13.8856 8.91094 14.0358 8.7627 14.1402 8.58353C14.2447 8.40436 14.2997 8.20068 14.2997 7.99328C14.2997 7.78588 14.2447 7.5822 14.1402 7.40303C14.0358 7.22386 13.8856 7.07562 13.7051 6.97345H13.7028ZM3.7026 13.1129L5.19206 8.70314H8.43756C8.62404 8.70314 8.80289 8.62906 8.93475 8.4972C9.06661 8.36534 9.14069 8.1865 9.14069 8.00002C9.14069 7.81354 9.06661 7.63469 8.93475 7.50283C8.80289 7.37097 8.62404 7.29689 8.43756 7.29689H5.19206L3.70202 2.88595L12.6528 7.99357L3.7026 13.1129Z",
    fill: "#0095F6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCollabApply);
export default __webpack_public_path__ + "static/media/icon_collab_apply.aa409008cd8138860e050bca1ba120a8.svg";
export { ForwardRef as ReactComponent };